import React, {memo, NamedExoticComponent, useRef, useState} from "react";
import {Button, ButtonToolbar, ControlLabel, FlexboxGrid, Form, FormControl, FormGroup, Panel, Schema} from "rsuite";
import styles from './lostPasswordPage.module.scss';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {FormInstance} from "rsuite/es/Form";
import {useHistory} from "react-router";
import PagePath from "../../../../routing/pagePath";
import {Account} from "../../../../services/api-service";

export const LostPasswordPage: NamedExoticComponent = memo(() => {
  const {t} = useTranslation();
  const history = useHistory();

  const { StringType } = Schema.Types;
  const model = Schema.Model({
    email: StringType()
      .isEmail(t('emailInvalid'))
      .isRequired(t('emailRequiredError'))
  });

  const formRef = useRef<FormInstance>(null);
  const [sendingRecoveryMail, setSendingStatus] = useState(false);
  const [formState, setFormState] = useState({
    email: ''
  });

  const sendRecoveryEmail = async () => {
    if( formRef.current === null ) {
      return;
    }

    let result = await formRef.current.checkAsync();

    if(result.hasError) {
      return;
    }

    setSendingStatus(true);

    try {
      await Account.accountLostPassword(formState.email);
      history.push({
        pathname: PagePath.RECOVER_PASSWORD,
        state: {
          email: formState.email
        }
      });
    } finally {
      setSendingStatus(false);
    }
  };

  return (
    <FlexboxGrid justify="center" align={"middle"} className={styles.wrapper}>

      <Panel header={t('LostPasswordScreenHeading')} bordered={true} shaded={false} className={styles.container}>

        <Form
          fluid={true}
          model={model}
          ref={formRef}
          onChange={formValue => {
            setFormState(formValue as any);
          }}
          formValue={formState}
        >
          <FormGroup>
            <ControlLabel>{t('email')}</ControlLabel>
            <FormControl
              name="email"
              type={'email'}
              errorPlacement={"bottomStart"}
              checkTrigger={"blur"}
              disabled={sendingRecoveryMail}
            />
          </FormGroup>
          <FormGroup>
            <ButtonToolbar className={styles.centerizeFirst}>
              <Button appearance="primary" disabled={sendingRecoveryMail} loading={sendingRecoveryMail} type="submit" onClick={sendRecoveryEmail}>
                {t('sendRecoveryEmail')}
              </Button>
            </ButtonToolbar>
            <div className={styles.or}>
              {t('or')}
            </div>
            <ButtonToolbar className={styles.centerizeLast}>
              <Button appearance="ghost" componentClass={Link} to={PagePath.LOGIN} disabled={sendingRecoveryMail}>
                {t('login')}
              </Button>
              <Button appearance="link" componentClass={Link} to={PagePath.REGISTER} disabled={sendingRecoveryMail}>
                {t('signUp')}
              </Button>
            </ButtonToolbar>
          </FormGroup>
        </Form>

      </Panel>

    </FlexboxGrid>
  )
})
